import { FormProvider, useForm } from 'react-hook-form'
import { Box, CircularProgress, Button } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { IconArrowRight } from '@tabler/icons-react'
import { Input } from '~/components'
import { useAuth } from '~/contexts'

export type LoginFormData = {
  installation: string
  powerPlantId: string
}

const schema = yup
  .object({
    installation: yup.string().required('Informe o número da instalação'),
    powerPlantId: yup.string().required('Informe o ID da usina'),
  })
  .required()

export const LoginForm: React.FC = () => {
  const { authLogin, loginIsLoading } = useAuth()

  const formMethods = useForm<LoginFormData>({
    resolver: yupResolver(schema),
  })

  return (
    <FormProvider {...formMethods}>
      <form style={{ width: '100%', display: 'flex', flexDirection: 'column' }} onSubmit={formMethods.handleSubmit((data) => authLogin(data))}>

        <Input label='Instalação' name='installation' />
        <Input
          label='ID da Usina'
          name='powerPlantId'
          style={{ margin: '24px 0px 36px 0px' }}
        />

        <Button
          disabled={loginIsLoading}
          style={{ fontSize: '16px', fontWeight: 600 }}
          variant='contained'
          color='primary'
          type='submit'
          endIcon={loginIsLoading
            ? <CircularProgress size={24} color='inherit' />
            : <IconArrowRight />
          }
        >
          Entrar
        </Button>

        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
        </Box>
      </form>
    </FormProvider>
  )
}
